export default __webpack_public_path__ + "static/media/sustainable.abbdd87d.JPG";